import React, { useEffect, useState } from 'react';
import { tableUseStyle } from '../../etc/tableusestyle';
import { DataGridPremium, gridFilteredSortedRowEntriesSelector, GridFilterModel, useGridApiRef } from '@mui/x-data-grid-premium';
import { Button } from '@mui/joy';
import { dateToDateString } from '../../etc/etcfunctions';
import { Autocomplete, Backdrop, Box, CircularProgress, Modal, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import totalLocationData from '../../../../../data/locationdata';
import CustomInput from '../../etc/custominput';
import { fil } from 'date-fns/locale';
import { postFetch } from '../../../../../fetch/fetch';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { on } from 'events';

const today = new Date();

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: "24px",
    boxShadow: 24,
    p: 3,
    paddingLeft: 5,
    paddingRight: 5
};

const PrintList: React.FC<any> = (props) => {

    const classes = tableUseStyle();
    const [rows, setRows] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([
        { field: "location", headerName: "지점", width: 100 },
        { field: "name", headerName: "이름", width: 100 },
        { field: "price", headerName: "비용", width: 100 },
        { field: "pages", headerName: "페이지 수", width: 80 },
        { field: "duplex", headerName: "단면/양면", width: 80 },
        { field: "document", headerName: "문서 이름", width: 150 },
        { field: "type", headerName: "종이 종류", width: 80 },
        { field: "printTime", headerName: "프린트 일시", width: 180 },
        { field: "isRefund", headerName: "환불 적용 일시", width: 180 },
        { field : "whoRefunded", headerName : "환불 처리자", width : 100 }
    ]);
    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alignment, setAlignment] = useState("total");
    const [alignment2, setAlignment2] = useState("paid");
    const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
        items: [
            { id: 2, field: 'name', operator: 'contains', value: "" },
            { id: 5, field: "location", operator: "isAnyOf", value: [] },
            { id: 7, field: "paid", operator: "contains", value: "X" }
        ],
    });

    const [update, setUpdate] = useState(0);
    const [name, setName] = useState("");

    const [selectedIds, setSelectedIds] = useState<any[]>([]);

    const [submitLoading, setSubmitLoading] = useState(false);

    const apiRef = useGridApiRef();

    const [open, setOpen] = useState(false);

    const [users, setUsers] = useState<any>([]);
    const [userLoading, setUserLoading] = useState(false);

    const [selectedUser, setSelectedUser] = useState<any>(null);

    const [selectedId, setSelectedId] = useState<any>(null);
    const [selectedRefundedAt, setSelectedRefundedAt] = useState<any>(null);

    useEffect(() => {

        getPrintData();

    }, [update]);


    const notify1 = () => toast.success("처리 성공!", {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: true,
        theme: "colored"
    });


    const getPrintData = async () => {

        try {

            setLoading(true);

            const response = await fetch("https://peetsunbae.com/dashboard/payments/print/totallog", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            });

            const result = await response.json();

            const data = result.data;

            const newRows: any = [];

            data.forEach((item: any, index: number) => {

                if (item.name === "user") {
                    return;
                }

                const oneRow: any = {};

                oneRow.id = item.id;
                oneRow.location = item.location;
                oneRow.name = item.studentName;
                oneRow.price = item.price.toLocaleString() + "원";
                oneRow.pages = item.page;
                oneRow.duplex = item.isDuplex  ? "양면" : "단면";
                oneRow.document = item.filePath.split("\\").pop().split(" ").pop();
                oneRow.type = item.type;
                oneRow.printTime = dateToDateString(new Date(item.createdAt), true);
                
                if(item.refundedAt){
                    oneRow.isRefund = dateToDateString(new Date(item.refundedAt), true);
                    oneRow.whoRefunded = item.teacherName;
                }

                newRows.push(oneRow);

            });

            newRows.sort((a: any, b: any) => {
                return new Date(b.printTime).getTime() - new Date(a.printTime).getTime();
            });

            setRows([...newRows]);

            setLoading(false);


        } catch (e) {
            console.log(e);
        }

    }

    const handleChange = (e: any, newAlignment: string) => {



        if (!newAlignment) {
            return;
        }

        setAlignment(newAlignment);

        const newFilterModel: any = filterModel;

        const locationList: any = [];

        totalLocationData.forEach((location) => {

            if (newAlignment === "total") {


            } else if (location.english === newAlignment) {
                //     
                //     
                //     

                // newFilterModel.items.forEach((each : any) => {
                //     if(each.id === 5){
                //         each.value = location.filterValue_contains;
                //     }});

                locationList.push(location.korean);
            }

        });

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 5) {
                each.value = locationList;
            }
        })



        setFilterModel({ ...newFilterModel });

    }

    const nameChange = (e: any) => {

        setName(e.target.value);

        const newFilterModel = filterModel;

        newFilterModel.items.forEach((each: any) => {

            if (each.id === 2) {
                each.value = e.target.value;
            }

        })

        setFilterModel({ ...newFilterModel });

    }

    const handleStateChange = (e: any) => {

        const filteredSortedEntries = gridFilteredSortedRowEntriesSelector(apiRef);

        var unmatchedCount = 0;
        var totalCost = 0;

        filteredSortedEntries.forEach((each: any) => {

            if (!each || !each.model) {
                return;
            }

            const isConnected = each.model.isConnected;

            if (isConnected === "계정 연결 안됨") {
                unmatchedCount++;
            }

            const price = each.model.priceNumber ? +each.model.priceNumber : 0;

            totalCost += price;

        });

    }

    const letsRefund = async () => {

        try{

            if(!window.confirm("정말로 환불시키겠습니까?")){
                return;
            }

            setBtnLoading(true);

            const result : any = await postFetch("/dashboard/payments//refundprintpayments", {
                printLogId : selectedId
            });

            if(result.message === "success"){
                notify1();
                setUpdate(Math.random());
            }

            setBtnLoading(false);

            setSelectedId(null);
            setSelectedRefundedAt(null);

        }catch(e){
            console.log(e);
        }

    }



    return (
        <div>

            <div style={{
                height : "30px"
            }}></div>

            <div style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "space-between",
                width: "1700px"
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",

                }}>
                    {/* <div style={{
                        marginRight: "30px"
                    }}>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment2}
                            exclusive
                            onChange={handleChange2}
                        >
                            <ToggleButton value="paid">전체</ToggleButton>
                            <ToggleButton value="notPaid">환불내역</ToggleButton>
                        </ToggleButtonGroup>
                    </div> */}
                    <div style={{
                        marginRight: "30px"
                    }}>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment}
                            exclusive
                            onChange={handleChange}
                        >
                            {
                                props.user && totalLocationData.filter((each) => each.academy.includes(props.user.academy)).map((each, index) => {
                                    return (
                                        <ToggleButton value={each.english} key={index}>{each.korean}</ToggleButton>
                                    )
                                })
                            }
                        </ToggleButtonGroup>
                    </div>
                    <span style={{
                        marginLeft: "20px"
                    }}>
                        <CustomInput value={name} onChange={nameChange} placeholder="이름 검색" />
                    </span>
                </div>
                <div>
                    <Button
                        variant='soft'
                        color='neutral'
                        onClick={letsRefund}
                        loading={btnLoading}
                        disabled={(!selectedId || (selectedRefundedAt)) ? true : false}
                        sx={{
                            marginRight: "15px"
                        }}
                    >
                        환불시키기
                    </Button>
                </div>

            </div>
            <div className={classes.root} style={{
                backgroundColor: "white",
                width: "1700px",
                height: "600px",
                marginTop: "10px"
            }}>
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    density='compact'
                    apiRef={apiRef}
                    filterModel={filterModel}
                    onFilterModelChange={(model) => {
                        setFilterModel(model);
                    }}
                    getCellClassName={(params: any) => {
                        if (params.field === "isConnected" && params.value === "계정 연결 안됨") {
                            return "redtext";
                        }
                        if (params.row.excepted) {
                            return "deleted";
                        }
                        return "";
                    }}
                    onStateChange={(e) => {
                        handleStateChange(e);
                    }}
                    onRowClick={(e) => {
                        console.log(e);
                        console.log(e.row.id);
                        setSelectedId(e.row.id);
                        setSelectedRefundedAt(e.row.isRefund);
                    }}
                    loading={loading}
                />
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={submitLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </div>
    )
}

export default PrintList;